/** 
    Copyright (C) 2024 Mathys Meunier

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You can receive a copy of the GNU General Public License
    along with this program at "http://mathysmeunier/license".
*/

import { useState } from "react";
import NavBarSmall from "./NavBarSmall";

export default function OpenNavBarSmallButton() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button className="sm:hidden mr-4" onClick={() => setIsOpen(o => !o)} aria-label="extend navBar">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" />
                </svg>
            </button>
            {isOpen &&
                <NavBarSmall onSelect={() => setIsOpen(false)} />
            }
        </>
    )
}
